// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../generated-types'

import gql from 'graphql-tag'
export type UserInfoFragment = {
  __typename?: 'Enquiry'
  guestId: number
  country: string
  guest?: {
    __typename?: 'Guest'
    firstName: string
    lastName?: string | null
    email?: string | null
  } | null
}

export const UserInfoFragmentDoc = gql`
  fragment UserInfo on Enquiry {
    guestId
    guest {
      firstName
      lastName
      email
    }
    country
  }
`
